import { ApiRequest } from '../services/api/request';

export default apiService => function apiMiddleware() {
  return next => (action) => {
    if (action.payload && action.payload instanceof ApiRequest) {
      return next({
        ...action,
        payload: apiService(action.payload)
      });
    }

    return next(action);
  };
};



// WEBPACK FOOTER //
// ./src/universal/ui/middleware/api.js